import {
  FolderOutlined,
  HomeOutlined,
  ImportOutlined,
  SettingOutlined,
  UnorderedListOutlined,
  UserOutlined
} from "@ant-design/icons";
import EASApplicationsImg from "assets/icons/navigation/eas-applications-navbar.svg";
import { AppURL } from "utils/Actions";
import {
  CONTACT_FIELD,
  FILTER_LABEL,
  FILTER_VALUE,
  RATING_LEVEL_CODE,
  RATING_SCORE_CODE,
  STATE_NAME,
  TABLE_FILTER,
  UTAS_RATING_SCORE_CODE
} from "./Constants";
import { ILogin, RoleType, StringIndexType, TRoleOption } from "./Types";
import { APP_ROLES } from "utils/Constants";

// imported page elements
import Dashboard from "pages/school-user/dashboard";
import Students from "pages/school-user/students";
import SRSApplications from "pages/school-user/srs-applications";
import Credentials from "pages/school-user/staff";
import Settings from "pages/school-user/settings";
import EASApplications from "pages/school-user/eas-applications";
import Ratings from "pages/school-user/ratings";

import uacLogo from "assets/logos/uac_logo.svg";
import utasLogo from "assets/logos/utas_logo.svg";
import UACLoginRight from "pages/auth/login/uac-right";
import UTASLoginRight from "pages/auth/login/utas-right";

export const studentTableSize = 10;

const EASApplicationsIcon = () => {
  return <img src={EASApplicationsImg} alt="" />;
};

export const NavMenus = [
  {
    title: "navMenus.home.label",
    exact: true,
    Icon: HomeOutlined,
    url: AppURL.school.path,
    isLanddingPage: true,
    isLogout: false,
    displayInMenu: true,
    roles: [APP_ROLES.ADMIN, APP_ROLES.SRS, APP_ROLES.EAS],
    Page: Dashboard
  },
  {
    title: "navMenus.students.label",
    exact: true,
    Icon: FolderOutlined,
    url: `${AppURL.school.students}`,
    isLanddingPage: false,
    isLogout: false,
    displayInMenu: true,
    roles: [APP_ROLES.ADMIN],
    Page: Students
  },
  {
    title: "navMenus.srsApplications.label",
    exact: true,
    Icon: UnorderedListOutlined,
    url: `${AppURL.school.rater.srsApplications}`,
    isLanddingPage: false,
    isLogout: false,
    displayInMenu: true,
    roles: [APP_ROLES.SRS, APP_ROLES.ADMIN],
    Page: SRSApplications
  },
  {
    title: "navMenus.ratings.label",
    exact: false,
    Icon: <></>,
    url: `${AppURL.school.rater.ratings}/:refNum`,
    isLanddingPage: false,
    isLogout: false,
    displayInMenu: false,
    roles: [APP_ROLES.SRS],
    Page: Ratings
  },
  {
    title: "navMenus.easApplications.label",
    exact: true,
    Icon: EASApplicationsIcon,
    url: `${AppURL.school.easApplications}`,
    isLanddingPage: false,
    isLogout: false,
    displayInMenu: true,
    roles: [APP_ROLES.EAS],
    Page: EASApplications
  },
  {
    title: "divider",
    isDivider: true
  },
  {
    title: "navMenus.staffMembers.label",
    exact: true,
    Icon: UserOutlined,
    url: `${AppURL.school.manageCredential}`,
    isLanddingPage: false,
    isLogout: false,
    displayInMenu: true,
    roles: [APP_ROLES.ADMIN],
    Page: Credentials
  },
  {
    title: "navMenus.myAccount.label",
    exact: true,
    Icon: SettingOutlined,
    url: `${AppURL.school.manageUser}`,
    isLanddingPage: false,
    isLogout: false,
    displayInMenu: true,
    roles: [APP_ROLES.ADMIN, APP_ROLES.SRS, APP_ROLES.EAS],
    Page: Settings
  }
];

export const LogoutNavMenu = {
  title: "navMenus.logout.label",
  Icon: ImportOutlined,
  url: "/logout",
  isLanddingPage: true,
  isLogout: true
};

export const ReportDays = [
  {
    label: "Monday",
    value: "1"
  },
  {
    label: "Tuesday",
    value: "2"
  },
  {
    label: "Wednesday",
    value: "3"
  },
  {
    label: "Thursday",
    value: "4"
  },
  {
    label: "Friday",
    value: "5"
  }
];

export const schoolContactLabel = {
  school: "School",
  role: "Role",
  username: "Email",
  usernameWithoutEmail: "Username",
  title: "Title",
  firstName: "First name",
  givenName2: "Middle name",
  lastName: "Last name",
  position: "Position",
  address: "Address",
  address1: "Address",
  address2: "Town or suburb",
  address3: "State/territory",
  postCode: "Postcode",
  phone: "Phone number",
  phoneMobile: "Mobile phone"
};

export const titles = [
  {
    value: "MR",
    label: "Mr."
  },
  {
    value: "MRS",
    label: "Mrs."
  },
  {
    value: "MS",
    label: "Ms."
  },
  {
    value: "MISS",
    label: "Miss"
  },
  {
    value: "DR",
    label: "Doctor"
  },
  {
    value: "MX",
    label: "Mx."
  }
];

export const states = [
  {
    value: STATE_NAME.ACT,
    label: "Australian Capital Territory"
  },
  {
    value: STATE_NAME.NSW,
    label: "New South Wales"
  },
  {
    value: STATE_NAME.QLD,
    label: "Queensland"
  },
  {
    value: STATE_NAME.SA,
    label: "South Australia"
  },
  {
    value: STATE_NAME.TAS,
    label: "Tasmania"
  },
  {
    value: STATE_NAME.VIC,
    label: "Victoria"
  },
  {
    value: STATE_NAME.WA,
    label: "Western Australia"
  },
  {
    value: STATE_NAME.IB,
    label: "International Baccalaureate"
  }
];

export const gender: StringIndexType = {
  M: "Male",
  F: "Female",
  X: "Indeterminate/ Intersex/ Unspecified"
};

export const ratingLevels = [
  {
    value: RATING_LEVEL_CODE.RSTL,
    label: "Literacy skills (especially writing)"
  },
  {
    value: RATING_LEVEL_CODE.RSTN,
    label: "Numeracy"
  },
  {
    value: RATING_LEVEL_CODE.RSTT,
    label: "Critical thinking"
  },
  {
    value: RATING_LEVEL_CODE.RSTM,
    label: "Time management and ability to manage workload"
  },
  {
    value: RATING_LEVEL_CODE.RSTC,
    label: "Collaborative skills"
  },
  {
    value: RATING_LEVEL_CODE.RSTI,
    label: "Ability to think independently and take responsibility for their own learning"
  },
  {
    value: RATING_LEVEL_CODE.RSTE,
    label: "Interested and engaged in learning"
  }
];

export const ratingScores = [
  {
    value: RATING_SCORE_CODE.EXCEPTIONAL,
    label: "Exceptional"
  },
  {
    value: RATING_SCORE_CODE.VERYGOOD,
    label: "Very good"
  },
  {
    value: RATING_SCORE_CODE.GOOD,
    label: "Good"
  },
  {
    value: RATING_SCORE_CODE.ADEQUATE,
    label: "Adequate"
  },
  {
    value: RATING_SCORE_CODE.INADEQUATE,
    label: "Inadequate "
  }
];

export const utasRatingScores = [
  {
    value: UTAS_RATING_SCORE_CODE.P,
    label: "Pathway"
  },
  {
    value: UTAS_RATING_SCORE_CODE.S,
    label: "Satisfactory"
  },
  {
    value: UTAS_RATING_SCORE_CODE.C,
    label: "Commendable"
  },
  {
    value: UTAS_RATING_SCORE_CODE.H,
    label: "High Achievement"
  }
];

export const settingFields: string[] = [
  CONTACT_FIELD.SCHOOL_NAME,
  CONTACT_FIELD.ROLE_ID,
  CONTACT_FIELD.EMAIL,
  CONTACT_FIELD.TITLE,
  CONTACT_FIELD.FIRST_NAME,
  CONTACT_FIELD.GIVEN_NAME_2,
  CONTACT_FIELD.LAST_NAME,
  CONTACT_FIELD.POSITION,
  CONTACT_FIELD.ADDRESS_1,
  CONTACT_FIELD.ADDRESS_2,
  CONTACT_FIELD.ADDRESS_3,
  CONTACT_FIELD.AUS_POST_CODE,
  CONTACT_FIELD.PHONE,
  CONTACT_FIELD.MOBILE
];

export const roleSRS: RoleType = {
  value: APP_ROLES.SRS,
  labelKey: "roles.SRS"
};
export const roleEAS: RoleType = {
  value: APP_ROLES.EAS,
  labelKey: "roles.EAS"
};

export const ROLE_OPTION: TRoleOption<RoleType[]> = {
  uac: [roleSRS, roleEAS],
  utas: [roleSRS]
};

// https://uac-cloud.atlassian.net/browse/ABKL-84
// show the oldest (asc) submission dates so they receive rating priority
export const defaultSorting = { field: "submissionDate", dir: "asc" };

export const appliedAdmOpt = [
  { label: FILTER_LABEL.YES, value: FILTER_VALUE.YES },
  { label: FILTER_LABEL.NO, value: FILTER_VALUE.NO }
];

export const srsLodgedOpt = [
  { label: FILTER_LABEL.YES, value: FILTER_VALUE.YES },
  { label: FILTER_LABEL.NO, value: FILTER_VALUE.NO }
];

export const schoolRatedOpt = [
  { label: FILTER_LABEL.RATED, value: FILTER_VALUE.RATED },
  { label: FILTER_LABEL.PARTIAL, value: FILTER_VALUE.PARTIAL },
  { label: FILTER_LABEL.UNRATED, value: FILTER_VALUE.UNRATED }
];

export const appliedAdmObj = {
  name: TABLE_FILTER.ADMIN_LODGED,
  yes: false,
  no: false
};

export const srsLodgedObj = {
  name: TABLE_FILTER.SRS_LODGED,
  yes: false,
  no: false
};

export const schoolRatedObj = {
  name: TABLE_FILTER.SCHOOL_RATED,
  rated: false,
  unrated: false,
  partial: false
};

export const filterItemAdmin = [appliedAdmObj, srsLodgedObj, schoolRatedObj];
export const filterItemSrs = [schoolRatedObj];

export const loginComponent: ILogin = {
  uac: {
    logo: uacLogo,
    right: <UACLoginRight />
  },
  utas: {
    logo: utasLogo,
    right: <UTASLoginRight />
  }
};

// Dummy data
export const dummyStudent1 = {
  key: "36278617",
  studentNumber: "36278617",
  refNum: 135613609,
  givenName1: "Vete",
  givenName2: "TES",
  familyName: "APPLICANT",
  address1: "12 BEEFSTEAK ROAD (PO BOX 688)",
  address2: "NORFOLK ISLAND",
  address3: "NSW",
  auPostCode: "2899",
  dob: "2005-07-11",
  sex: "F",
  resultCode: "SNSW05",
  schoolCode: "01327",
  srsLodged: true,
  admissionApplicationStatus: "L",
  applicationMode: "UG-DOMESTIC",
  schoolRated: "Not Rated"
};

export const utasSummaryReportCSVHeaders = [
  { label: "S.No", key: "rowNum" },
  { label: "Student number", key: "studentNumber" },
  { label: "Given name", key: "givenName1" },
  { label: "Family name", key: "familyName" },
  { label: "Date of birth", key: "dob" },
  { label: "Submission Date", key: "formattedSubmissionDate" },
  { label: "Rated", key: "rated" },
  { label: "Literacy skills", key: "scores.literacy" },
  { label: "Numeracy skills", key: "scores.numeracy" },
  { label: "Critical thinking skills", key: "scores.critical_thinking" },
  { label: "Time/Workload management", key: "scores.management" },
  { label: "Collaborative skills", key: "scores.collaborative" },
  { label: "Independence skills", key: "scores.independence" },
  { label: "Learning interest", key: "scores.learning_interest" },
  { label: "Rating submitted", key: "ratingSubmitted" }
];

export const uacSummaryReportCSVHeaders = [
  { label: "S.No", key: "rowNum" },
  { label: "Student ID", key: "studentNumber" },
  { label: "First name", key: "givenName1" },
  { label: "Family name", key: "familyName" },
  { label: "Date of birth", key: "dob" },
  { label: "Submission Date", key: "formattedSubmissionDate" },
  { label: "Rated", key: "rated" },
  { label: "Abstract thought", key: "scores.abstract_thought" },
  { label: "Organisation", key: "scores.organisation" },
  { label: "Independence", key: "scores.independence" },
  { label: "Motivation", key: "scores.motivation" },
  { label: "Rating submitted", key: "ratingSubmitted" }
];

export const uacEISReportCSVHeaders = [
  {
    label: "Student ID",
    key: "studentNumber"
  },
  {
    label: "File Name",
    key: "documentName"
  },
  {
    label: "File Reference",
    key: "fileReference"
  },
  {
    label: "File Submitted",
    key: "dateSubmitted"
  }
];